// extracted by mini-css-extract-plugin
export var progressBar = "_lx-0";
export var progressBarInner = "_lx-1";